import {
	createRouter,
	createWebHistory
} from 'vue-router'
import axios from "axios"
import api from '../utils/index.js'

const Home = () => import('../views/Home.vue')
const Login = () => import('../views/Login.vue')
const Register = () => import('../views/Register.vue')
const ResetPassword = () => import('../views/ResetPassword.vue')
const Onlineexamination = () => import('../views/Onlineexamination.vue')
const Personal = () => import('../views/Personal.vue')
const Knowledgebase = () => import('../views/Knowledgebase.vue')
const Knowledgebase2 = () => import('../views/Knowledgebase2.vue')
const knowledgebasedetails = () => import('../components/knowledgebasedetails/knowledgebasedetails.vue')
const knowledgebasedetails2 = () => import('../components/knowledgebasedetails/knowledgebasedetails2.vue')
const Item2 = () => import('../views/Item2.vue')
const Item3 = () => import('../views/Item3.vue')
const Item5 = () => import('../views/Item5.vue')
const Item4 = () => import('../views/Item4.vue')
const Item6 = () => import('../views/Item6.vue')
const Item4base = () => import('../views/Item4base.vue')
const VR = () => import('../views/VR.vue')


const routes = [{
		path: '/',
		name: 'Login',
		component: Login,
		meta: {
			title: "登录",
			changeToken: false
		}
	}, {
		path: '/vr',
		name: 'VR',
		component: VR,
		meta: {
			title: "云游药王山",
			changeToken: true
		}
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		meta: {
			title: "主页",
			changeToken: true
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta: {
			title: "注册",
			changeToken: false
		}
	},
	{
		path: '/resetpassword',
		name: 'ResetPassword',
		component: ResetPassword,
		meta: {
			title: "重置密码",
			changeToken: false
		}
	},
	{
		path: '/onlineexamination',
		name: 'Onlineexamination',
		component: Onlineexamination,
		meta: {
			title: "在线考试",
			changeToken: true
		}
	},
	{
		path: '/personal',
		name: 'Personal',
		component: Personal,
		meta: {
			title: "个人中心",
			changeToken: true
		},
		children:[
			{
				path:'/personal/',
				redirect: '/personal/usermodule'
			},
			{
				path:'/personal/usermodule',
				component: ()=>import('../components/usermodule/usermodule.vue'),
				meta: {
					title: "个人中心",
					changeToken: true
				},
				children:[
					{
						path:'/personal/usermodule',
						redirect: '/personal/usermodule/learningrecords'
					},
					{
						path:'/personal/usermodule/learningrecords',
						component: ()=>import('../components/learningrecords/learningrecords.vue'),
						meta: {
							title: "学习记录",
							changeToken: true
						}
					},
					{
						path:'/personal/usermodule/achievement',
						component: ()=>import('../components/achievement/achievement.vue'),
						meta: {
							title: "考试成绩",
							changeToken: true
						}
					},
					{
						path:'/personal/usermodule/messagereply',
						component: ()=>import('../components/messagereply/messagereply.vue'),
						meta: {
							title: "留言和回复",
							changeToken: true
						}
					},
					{
						path:'/personal/usermodule/specialcolumn',
						component: ()=>import('../components/specialcolumn/specialcolumn.vue'),
						meta: {
							title: "文章专栏",
							changeToken: true
						}
					}
				]
			},
			{
				path:'/personal/changepassword',
				component: ()=>import('../components/changepassword/changepassword.vue'),
				meta: {
					title: "修改密码",
					changeToken: true
				}
			}
		]
	},
	{
		path: '/knowledgebase',
		name: 'Knowledgebase',
		component: Knowledgebase,
		meta: {
			title: "知识库",
			changeToken: true
		},
	},{
		path: '/knowledgebase2',
		name: 'Knowledgebase2',
		component: Knowledgebase2,
		meta: {
			title: "文章专题",
			changeToken: true
		},
	},
	{
		path: '/knowledgebasedetails',
		name: 'knowledgebasedetails',
		component: knowledgebasedetails,
		meta: {
			title: "知识库",
			changeToken: true,
			starttime: null
		}
	},
	{
		path: '/knowledgebasedetails2',
		name: 'knowledgebasedetails2',
		component: knowledgebasedetails2,
		meta: {
			title: "文章专栏",
			changeToken: true,
			starttime: null
		}
	}
	,
	{
		path: '/item5',
		name: 'Item5',
		component: Item5,
		meta: {
			title: "养生篇",
			changeToken: true
		}
	},
	{
		path: '/item4',
		name: 'Item4',
		component: Item4,
		meta: {
			title: "典故篇",
			changeToken: true
		}
	},
	{
		path: '/item4base',
		name: 'Item4base',
		component: Item4base,
		meta: {
			title: "典故篇",
			changeToken: true
		}
	},
	{
		path: '/item6',
		name: 'Item6',
		component: Item6,
		meta: {
			title: "医德篇",
			changeToken: true
		}
	},
	{
		path: '/item3',
		name: 'Item3',
		component: Item3,
		meta: {
			title: "著作篇",
			changeToken: true
		}
	},
	{
		path: '/item2',
		name: 'Item2',
		component: Item2,
		meta: {
			title: "智慧篇",
			changeToken: true
		}
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes
})
router.beforeEach((to, from, next) => {
	let starttime = null
	let endtime = null
	if (to.path === '/knowledgebasedetails') {
		let yy = new Date().getFullYear();
		let mm = new Date().getMonth() + 1;
		let dd = new Date().getDate();
		let hh = new Date().getHours();
		let mf =
			new Date().getMinutes() < 10 ?
			"0" + new Date().getMinutes() :
			new Date().getMinutes();
		let ss =
			new Date().getSeconds() < 10 ?
			"0" + new Date().getSeconds() :
			new Date().getSeconds();
		starttime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
		to.meta.starttime = starttime
	}
	if (from.path === '/knowledgebasedetails') {
		let yy = new Date().getFullYear();
		let mm = new Date().getMonth() + 1;
		let dd = new Date().getDate();
		let hh = new Date().getHours();
		let mf =
			new Date().getMinutes() < 10 ?
			"0" + new Date().getMinutes() :
			new Date().getMinutes();
		let ss =
			new Date().getSeconds() < 10 ?
			"0" + new Date().getSeconds() :
			new Date().getSeconds();
		endtime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
		let token = sessionStorage.getItem('token')
		let userid = sessionStorage.getItem('userid')
		let jsondata = {
			"startTime": from.meta.starttime,
			"endTime": endtime,
			"kId": from.query.id,
			"userId": userid,
			"type": '1'
		}
		axios({
			url: api.commonUrl + "study/insert",
			method: "POST",
			data: jsondata,
			headers: {
				Authorization: "Bearer " + token,
			},
		}).then((res) => {
			console.log(res)
		}).catch((err) => {
			console.log(err);
		})
	}
	document.title = to.matched[0].meta.title


	if (to.matched[0].meta.changeToken) {
		let token = sessionStorage.getItem('token');
		if (token === null || token === '') {
			next('/')
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
